import { useEffect, useState } from "react";
import { Image, MessageCircle, Send, Smile, X, XCircle } from "react-feather";
import {
  Button,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  UncontrolledDropdown,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getUserByEmail } from "@store/action/auth/AuthAction";
import { toast } from "react-toastify";
import {
  getMessagesOpenedThread,
  insertMessage,
} from "@store/action/chat/MessageAction";
import {
  insertParticipant,
  getParticipantId,
} from "@store/action/chat/ParticipantAction";
import {
  getOpenedThreadByRadioId,
  getThreadById,
} from "@store/action/chat/GroupAction";
import { escapeXmlTags, getDateString } from "@store/action/GlobalAction";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);
import GoogleAuthChat from "@src/auth/socialAuth/GoogleAuthChat";
import PerfectScrollbar from "react-perfect-scrollbar";
import Avatar from "@components/avatar";
import classnames from "classnames";
import Janus from "janus-gateway";
import adapter from "webrtc-adapter";
import defaultAvatar from "@src/assets/images/portrait/small/avatar-s-18.jpg";
import EmojiPicker from "emoji-picker-react";
import "@src/@core/scss/base/pages/app-chat.scss";
import "@src/@core/scss/base/pages/app-chat-list.scss";
import "./emoji.scss";

const REACT_APP_JANUS_SERVER = process.env.REACT_APP_JANUS_SERVER;

const GroupChat = () => {
  // ** State
  const radio_id = localStorage.getItem("radio_id");
  const dispatch = useDispatch();
  const MessageReducer = useSelector((state) => state.MessageReducer);
  const chatReducer = useSelector((state) => state.GroupeChatReducer);
  const ParticipantReducer = useSelector((state) => state.ParticipantReducer);
  const authReducer = useSelector((state) => state.auth.user_by_email);
  const [openCustomizer, setOpenCustomizer] = useState(false);
  const [join_now, setJoin_now] = useState(false);
  const [msg, setMsg] = useState("");
  const [chatRef, setChatRef] = useState(null);
  const [publisherConnect, setPublisherConnect] = useState(false);
  const [newMessage, setNewMessage] = useState({});
  const [image, setImage] = useState(null);
  const [imageToDisplay, setImageToDisplay] = useState(null);
  const social_user = useSelector((state) => state.auth.social_user);
  const group_id = chatReducer.openedthreadbyradioId?.id;
  const handleToggle = (e) => {
    e.preventDefault();
    setOpenCustomizer(!openCustomizer);
  };
  const joinNow = () => {
    dispatch(
      insertParticipant({
        is_admin: true,
        is_blocked: false,
        user: authReducer.id,
        thread: group_id,
      })
    );
  };
  const scrollToBottom = () => {
    chatRef.scrollTop = Number.MAX_SAFE_INTEGER;
  };
  const renderMessages = () => {
    if (MessageReducer.messagesOpenedThread) {
      return MessageReducer.messagesOpenedThread.items.map((item, index) => (
        <div
          key={index}
          className={classnames("chat", {
            "chat-left": item.owner?.user.email !== username,
          })}
        >
          <div className="chat-avatar">
            <Avatar
              imgWidth={36}
              imgHeight={36}
              className="box-shadow-1 cursor-pointer"
              img={
                item.owner?.user.avatar
                  ? item.owner?.user.avatar
                  : defaultAvatar
              }
            />

            <span className="ms-1"> [{getDateString(item.created_at)}] </span>
          </div>
          <div className="chat-body">
            <div className="chat-content">
              <p>
                <b>{item.owner?.user.first_name}:</b>
                {item.type.id === 2 ? (
                  <span className="me-25">
                    <img
                      className="img-chat"
                      src={item.body}
                      onClick={() => {
                        showImage(item.body);
                      }}
                    />
                  </span>
                ) : item.type.id === 2 ? (
                  <video src={item.body} height="100" width="100" />
                ) : item.type.id === 3 ? (
                  item.body
                ) : (
                  item.body
                )}
              </p>
            </div>
          </div>
        </div>
      ));
    } else {
      return null;
    }
  };

  const handleSendMsg = (e) => {
    const data = {
      owner: ParticipantReducer.participantById?.id,
      body: msg,
      type: 1,
    };
    e.preventDefault();
    if (msg.length) {
      dispatch(
        insertMessage(data, () => {
          sendData(msg);
          setMsg("");
          setNewMessage({});
        })
      );
    }
  };
  const handleSendImage = (e) => {
    const data = {
      owner: ParticipantReducer.participantById.id,
      body: image,
      type: 2,
    };
    e.preventDefault();
    if (image) {
      dispatch(
        insertMessage(data, () => {
          sendImage();
          setImageToDisplay(null);
          setImage(null);
        })
      );
    }
  };
  const sendFullMessage = (e) => {
    msg && handleSendMsg(e);
    image && handleSendImage(e);
  };
  useEffect(() => {
    if (social_user !== null) {
      dispatch(getUserByEmail(social_user.email));
    }
  }, [social_user]);
  useEffect(() => {
    authReducer && join_now && joinNow();
  }, [authReducer, join_now]);
  useEffect(() => {
    if (
      newMessage.id &&
      chatReducer.threadsbyId.participant &&
      chatReducer.threadsbyId.participant.length
    ) {
      if (newMessage.email)
        newMessage.owner = participant.filter(
          (el) => el.user.email == newMessage.email
        )[0];
      MessageReducer.messagesOpenedThread.items.push(newMessage);
      setNewMessage({});
      chatReducer.threadsbyId.participant = [];
    }
  }, [newMessage, chatReducer.threadsbyId]);
  useEffect(() => {
    ParticipantReducer.participantById?.id &&
      dispatch(getParticipantId(ParticipantReducer.participantById?.id));
  }, [ParticipantReducer.participantById?.id]);
  useEffect(() => {
    openCustomizer &&
      MessageReducer.messagesOpenedThread &&
      join_now &&
      scrollToBottom();
  }, [
    publisherConnect,
    openCustomizer,
    MessageReducer.messagesOpenedThread,
    newMessage,
    join_now,
  ]);
  useEffect(() => {
    radio_id && dispatch(getMessagesOpenedThread(parseInt(radio_id)));
    radio_id && dispatch(getOpenedThreadByRadioId(parseInt(radio_id)));
  }, [radio_id, join_now]);
  useEffect(() => {
    group_id && dispatch(getThreadById(group_id));
  }, [group_id]);

  var myid = null;
  var participant = chatReducer.threadsbyId.participant;
  var participants = {};
  var transactions = {};
  var myroom = group_id;
  var username = ParticipantReducer.participantId?.user?.email;
  var janus = null;
  var textroom = null;
  var opaqueId = "textroomtest-" + Janus.randomString(12);
  const [textroom__, setTextroom__] = useState(null);
  const room_id = document.getElementById("chatroom");

  useEffect(() => {
    chatRef &&
      room_id &&
      group_id &&
      ParticipantReducer.participantId &&
      authReducer &&
      Janus.init({
        debug: false,
        dependencies: Janus.useDefaultDependencies({ adapter: adapter }),
        callback: () => {
          janus = new Janus({
            server: REACT_APP_JANUS_SERVER,
            success: () => {
              chatReducer.threadsbyId.participant = [];
              janus.attach({
                plugin: "janus.plugin.textroom",
                opaqueId: opaqueId,
                success: function (pluginHandle) {
                  textroom = pluginHandle;
                  setTextroom__(pluginHandle);
                  // Setup the DataChannel
                  let body = { request: "setup" };
                  pluginHandle.send({ message: body });
                },
                error: function (error) {
                  console.error("  -- Error attaching plugin...", error);
                },
                onmessage: function (msg, jsep) {
                  if (jsep) {
                    // Answer
                    textroom.createAnswer({
                      jsep: jsep,
                      // We only use datachannels
                      tracks: [{ type: "data" }],
                      success: function (jsep) {
                        let body = { request: "ack" };
                        textroom.send({ message: body, jsep: jsep });
                      },
                      error: function (error) {
                        console.log("WebRTC error... " + error.message);
                      },
                    });
                  }
                },
                ondataopen: function (label, protocol) {
                  registerUsername();
                },
                ondata: function (data) {
                  let json = JSON.parse(data);
                  if (json["textroom"]) {
                    if (json.error) {
                      toast.error(json.error, {
                        icon: false,
                        hideProgressBar: true,
                        autoClose: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                      });
                    }
                  }
                  let transaction = json["transaction"];
                  if (transactions[transaction]) {
                    // Someone was waiting for this
                    transactions[transaction](json);
                    delete transactions[transaction];
                    return;
                  }
                  let what = json["textroom"];
                  if (what === "message") {
                    // Incoming message: public or private?
                    let msg = escapeXmlTags(json["text"]);
                    let from = json["from"];
                    // Public message
                    const owner = participant.filter((el) =>
                      myid === from
                        ? el.user.email == username
                        : el.user.email == participants[from]
                    )[0];
                    const newmsg = {
                      body: msg,
                      created_at: json["date"],
                      id: Janus.randomString(8),
                      owner: owner ? owner : null,
                      email: owner ? null : participants[from],
                      updated_at: json["date"],
                      type: {
                        id: 1,
                        name: "text",
                      },
                    };
                    setNewMessage(newmsg);
                    dispatch(getThreadById(group_id));
                  } else if (what === "announcement") {
                    // Room announcement
                    dispatch(getMessagesOpenedThread(parseInt(radio_id)));
                  } else if (what === "join") {
                    // Somebody joined
                    let username = json["username"];
                    let display = json["display"];
                    participants[username] = escapeXmlTags(
                      display ? display : username
                    );
                    setTimeout(() => {
                      setPublisherConnect(true);
                    }, 1000);
                  } else if (what === "leave") {
                    // Somebody left
                    let username = json["username"];
                  } else if (what === "kicked") {
                    // Somebody was kicked
                    let username = json["username"];
                  } else if (what === "destroyed") {
                    if (json["room"] !== myroom) return;
                  }
                },
              });
            },
            error: (err) => {
              console.log("errr", err);
            },
          });
        },
      });
  }, [
    chatRef,
    authReducer,
    room_id,
    group_id,
    ParticipantReducer.participantId,
  ]);
  function registerUsername() {
    myid = Janus.randomString(12);
    let transaction = Janus.randomString(12);
    let register = {
      textroom: "join",
      transaction: transaction,
      room: myroom,
      username: myid,
      display: username,
    };
    transactions[transaction] = function (response) {
      // Any participants already in?
      if (response.participants && response.participants.length > 0) {
        for (let i in response.participants) {
          let p = response.participants[i];
          participants[p.username] = escapeXmlTags(
            p.display ? p.display : p.username
          );
        }
      }
    };
    textroom.data({
      text: JSON.stringify(register),
      error: function (reason) {},
    });
  }
  function sendData(msg_text) {
    let message = {
      textroom: "message",
      transaction: Janus.randomString(12),
      room: myroom,
      text: msg_text,
    };
    textroom__.data({
      text: JSON.stringify(message),
      error: function (reason) {},
      success: function () {},
    });
  }
  const sendImage = () => {
    let message = {
      textroom: "announcement",
      room: myroom,
      text: "announcement",
      transaction: Janus.randomString(12),
    };
    textroom__.data({
      text: JSON.stringify(message),
      error: function (reason) {},
      success: function () {},
    });
  };
  const showImage = (file) => {
    return MySwal.fire({
      html: (
        <div>
          <img src={file} height="100%" width="100%" />
        </div>
      ),
      padding: "0px",
      margin: "0px",
      showCancelButton: false,
      showConfirmButton: false,
      customClass: {
        htmlContainer: "swal2-html-containers",
        container: "swal2-containers",
        popup: "swal2-popups",
      },
    });
  };
  useEffect(() => {
    MessageReducer.error?.body &&
      toast.error(MessageReducer.error.body, {
        icon: false,
        hideProgressBar: true,
        autoClose: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
  }, [MessageReducer.error]);

  return (
    <div
      className={classnames("customizer", {
        open: openCustomizer,
      })}
      style={{
        zIndex: 4,
        backgroundColor: "#fa5b41",
      }}
    >
      <a
        href="/"
        className={classnames(
          "customizer-toggle d-flex align-items-center justify-content-center",
          {
            open: openCustomizer,
          }
        )}
        onClick={handleToggle}
        style={{ backgroundColor: "#fa5b41" }}
      >
        <MessageCircle size={25} />
        <span className="ms-1">Live Chat</span>
      </a>
      <div className="customizer-header px-2 pt-1 pb-1 position-relative">
        <h4 className="mb-0">Live Chat</h4>
        <p className="m-0">Chat & Preview in Real Time</p>
        <a href="/" className="customizer-close" onClick={handleToggle}>
          <X />
        </a>
      </div>
      <PerfectScrollbar
        className="customizer-content"
        options={{ wheelPropagation: false }}
      >
        <div className="chat-app-window" style={{ height: "96%" }}>
          <div className={classnames("active-chat")}>
            <PerfectScrollbar
              containerRef={(el) => setChatRef(el)}
              className="user-chats scroll-area"
              options={{ wheelPropagation: false }}
            >
              {authReducer && join_now ? (
                <div className="chats" id="chatroom">
                  {renderMessages()}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {authReducer ? (
                    <Button onClick={() => setJoin_now(true)}>Join now</Button>
                  ) : (
                    <GoogleAuthChat setJoin_now={setJoin_now} />
                  )}
                </div>
              )}
            </PerfectScrollbar>
            <div className="fixedChatInput">
              <Form
                className="chat-app-form"
                onSubmit={(e) =>
                  publisherConnect ? sendFullMessage(e) : e.preventDefault()
                }
              >
                <InputGroup className="input-group-merge me-1 form-send-message">
                  <Input
                    style={{
                      backgroundColor: "inherit",
                      borderColor: "#fa5b41",
                    }}
                    value={msg}
                    onChange={(e) => setMsg(e.target.value)}
                    placeholder="Type your message or use speech to text"
                    disabled={!publisherConnect}
                  />
                  <InputGroupText
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <Label className="attachment-icon mb-0" for="attachs-doc">
                      <Image
                        className="cursor-pointer text-secondary"
                        size={14}
                      />
                      <input
                        type="file"
                        id="attachs-doc"
                        hidden
                        value=""
                        disabled={!publisherConnect}
                        onChange={(file) => {
                          const reader = new FileReader();
                          const { files } = file.target;
                          setImage(files[0]);
                          if (files && files.length !== 0) {
                            reader.onload = () => {
                              setImageToDisplay(reader.result);
                            };
                            reader.readAsDataURL(files[0]);
                          }
                        }}
                      />
                    </Label>
                    <Label className="attachment-icon ">
                      <UncontrolledDropdown
                        disabled={!publisherConnect}
                        style={{
                          backgroundColor: "white",
                        }}
                        direction="up"
                      >
                        <DropdownToggle
                          color="primary"
                          tag="p"
                          style={{
                            marginTop: "3px",
                            marginLeft: "5px",
                          }}
                        >
                          <Smile
                            className="cursor-pointer text-secondary"
                            size={14}
                          />
                        </DropdownToggle>
                        <DropdownMenu
                          style={{
                            backgroundColor: "white",
                          }}
                        >
                          <EmojiPicker
                            height="400px"
                            skinTonesDisabled={true}
                            emojiStyle="native"
                            onEmojiClick={(emoji) => {
                              setMsg(msg + emoji.emoji);
                            }}
                          />
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </Label>
                  </InputGroupText>
                </InputGroup>
                <Button
                  className="send"
                  color="primary"
                  disabled={msg.length === 0 && !image}
                >
                  <Send size={14} className="d-lg-none" />
                  <span className="d-none d-lg-block">Send</span>
                </Button>
              </Form>
              <div className="image-container">
                {imageToDisplay && (
                  <>
                    <img
                      style={{
                        bottom: "30px",
                      }}
                      id="imageToDisplay"
                      src={imageToDisplay}
                      height="70"
                      width="70"
                    />
                    <div
                      className="after"
                      onClick={() => {
                        setImage(null);
                        setImageToDisplay(null);
                      }}
                    >
                      <p>
                        <XCircle />
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default GroupChat;
